module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_60-e77b70d3a40ac7530ac49a414e4b80d6.png";